import { service } from '@ember/service';
import Component from '@glimmer/component';

import { trackedFunction } from 'reactiveweb/function';

import ContentItems from 'umg-ember-backend/components/page-builder/content-items';

export default class PageBuilderContentItemsItemForPageBuilderZatap extends Component {
  // Services
  @service pageBuilderFrontendApi;

  // Getter and setter
  get zatapConfig() {
    return this.themeConfig?.cms?.['mlp-zatap'];
  }

  get themeConfig() {
    return this.loadThemeConfig.value;
  }

  // Functions
  loadThemeConfig = trackedFunction(this, async () => {
    return await this.pageBuilderFrontendApi.loadThemeConfig(
      this.pageBuilderFrontendApi.host,
      this.args.mlp,
    );
  });

  // Template
  <template>
    <ContentItems
      @contentItems={{@contentItem.children}}
      @contentItemTypeOptions={{this.zatapConfig.contentItems}}
      @direction='y'
      @isDisabled={{@isDisabled}}
      @mlp={{@mlp}}
      @onSelectContentItem={{@onSelectContentItem}}
      @onSaveMlp={{@onSaveMlp}}
      @parent={{@contentItem}}
      @selectedContentItem={{@selectedContentItem}}
    >
      <h3>
        {{@contentItem.displayHeadline}}
      </h3>
    </ContentItems>
  </template>
}
